(function($) {
	
	const $blocks = $('.wp-block-metropolis-tabbed-content');
	
	$blocks.each( function() {
		
		const $wrapper = $(this);
		const $tabs = $wrapper.find('.tabbed-content-nav');
		const $sections = $wrapper.find('.wp-block-metropolis-tabbed-content-section');
		const $nav = $('<nav>');
		
		if( $wrapper.closest('section').next().hasClass('has-light-gray-background-color') ) {
			$wrapper.addClass('remove-spacing');
		}
		
		$sections.each( function(i) {
			
			const $this = $(this);
			const content = $('<div class="tab">');
			
			if( i == 0 ) content.addClass('active');
			
			$this.find('.icon-wrap').appendTo(content);
			content.append('<span class="label">' + $this.data('section-title') + '</span>')
			$nav.append(content);
			
		}).first().addClass('active');
		
		const $tab = $tabs.find('.tab');
		
		$tabs.append($nav).on('click', '.tab', function() {
			const index = $(this).index();
			$(this).addClass('active').siblings().removeClass('active');
			$sections.removeClass('active').eq(index).addClass('active');
		});
	
	});
	
})(jQuery);